/*
 * Copyright Deskshare Inc.
 * All rights reserved.
 *
 * This software is proprietary and confidential.
 * Unauthorized copying, distribution, or use is strictly prohibited.
 */

import React from "react";
import { Link } from "react-router-dom";
import "../../static/css/common/footer.css";
import { useTranslation } from "react-i18next";
import { AddLangToPath } from "@/helper/AddLanguagePath";
import { useWindowWidth } from "@/hooks/useWindowWidth";

const Footer: React.FC = () => {
  const { t } = useTranslation();
  const windowWidth = useWindowWidth(1000);

  const isDesktopDevice = windowWidth >= 1024;
  const showDownloadLink = windowWidth > 1000;

  return (
    <footer className="footer">
      <div className="footer-content">
        <span>
          <Link className="footer-text" to={AddLangToPath("/")}>
            {t("footer.home")}
          </Link>
        </span>
        {showDownloadLink && (
          <>
            {" "}|{" "}
            <span>
              <Link className="footer-text" to={AddLangToPath("/download/")}>
                {t("footer.download")}
              </Link>
            </span>
          </>
        )}{" "}
        |{" "}
        <span>
          <Link className="footer-text" to={AddLangToPath("/product-support/")}>
            {t("footer.support")}
          </Link>
        </span>{" "}
        |{" "}
        <span>
          <Link className="footer-text" to={AddLangToPath("/about-deskshare/")}>
            {t("footer.about")}
          </Link>
        </span>{" "}
        |{" "}
        <span>
          {isDesktopDevice ? (
            <a
              className="footer-text"
              href={AddLangToPath("/privacy-policy/?standalone=true")}
              target="_blank"
              rel="noopener noreferrer"
              onClick={(e) => {
                if (
                  e.button === 0 &&
                  !e.ctrlKey &&
                  !e.shiftKey &&
                  !e.metaKey &&
                  !e.altKey
                ) {
                  e.preventDefault();
                  const newWindow = window.open(
                    AddLangToPath("/privacy-policy/?standalone=true"),
                    "_blank",
                    "width=600,height=600,left=0,top=0,noopener,noreferrer",
                  );

                  if (
                    !newWindow ||
                    newWindow.closed ||
                    typeof newWindow.closed === "undefined"
                  ) {
                    window.open(
                      AddLangToPath("/privacy-policy/?standalone=true"),
                      "_blank",
                      "noopener,noreferrer",
                    );
                  }
                }
              }}
            >
              {t("footer.privacy_policy")}
            </a>
          ) : (
            <a
              className="footer-text"
              href={AddLangToPath("/privacy-policy/?standalone=true")}
              target="_blank"
              rel="noopener noreferrer"
            >
              {t("footer.privacy_policy")}
            </a>
          )}
        </span>{" "}
        |{" "}
        <span>
          <Link className="footer-text" to={AddLangToPath("/contact-us/")}>
            {t("footer.contact_us")}
          </Link>
        </span>
      </div>

      <div className="end">{t("footer.copyrite")}</div>
    </footer>
  );
};

export default Footer;
